import React, { useEffect, useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';

interface IMTextFieldProps {
  label: string;
  value?: string | number | null;
  icon?: React.ReactElement | null;
  onChange?: (value: any) => void;
  onIconClick?: () => void;
  required?: boolean;
  disabled?: boolean;
  numberOnly?: boolean;
  classNames?: string;
  placeholder?: string;
  maxLength?: number;
}

const MTextField: React.FunctionComponent<IMTextFieldProps> = ({
  label,
  value,
  icon,
  onChange,
  onIconClick,
  required,
  disabled,
  numberOnly,
  classNames,
  placeholder,
  maxLength,
}) => {
  const [shrink, setShrink] = useState(true);
  const [focus, setFocus] = useState(false);

  useEffect(() => {
    if (value) {
      setShrink(true);
    } else if (disabled && !value) {
      setShrink(false);
    } else if (focus) {
      setShrink(true);
    } else if (!focus && !disabled && !value) {
      setShrink(false);
    } else {
      setShrink(false);
    }
  }, [focus, disabled, value]);
  return (
    <FormControl fullWidth>
      <TextField
        id={`text-field-${label}`}
        data-testid={`text-field-${label}`}
        label={label}
        value={value}
        required={required}
        variant="standard"
        className={`text-field ${classNames}`}
        onChange={onChange}
        disabled={disabled}
        inputProps={{
          maxLength: maxLength,
        }}
        type={numberOnly ? 'number' : 'text'}
        sx={{
          '& .MuiFormLabel-asterisk': {
            color: 'red',
          },
        }}
        onFocus={() => {
          setFocus(true);
        }}
        onBlur={() => {
          setFocus(false);
        }}
        InputLabelProps={{ shrink: shrink }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton disabled={disabled} onClick={onIconClick}>
                {icon}
              </IconButton>
            </InputAdornment>
          ),
        }}
        placeholder={placeholder}
      />
    </FormControl>
  );
};

export default MTextField;
